class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/business-address`;
    }
    /**
     * Returns business address of a company.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/business-address
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the business address of a company that account is linked
     * to.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/business-address
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */
    async put(modifyAccountBusinessAddressRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), modifyAccountBusinessAddressRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
